import { FileVideoIcon, PlusIcon } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { VideoNoticeDialog } from '@admin/components/forms/video-notices/video-notice-dialog.tsx';
import { VideoNoticesTable } from '@admin/components/video-notices/video-notices-table.tsx';
import { Button } from '@ui/button.tsx';
import { Card, CardContent } from '@ui/card.tsx';

/**
 * Page Mega Admin permettant de créer, modifier et supprimer les notices vidéo.
 */
export function VideoInstructions() {
  const { t } = useTranslation();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  return (
    <>
      <div className="space-y-6">
        <h1 className="text-4xl font-bold">{t('fiddy.admin.video.notices.page.title')}</h1>

        <Card>
          <CardContent className="space-y-4 p-6">
            <div className="flex items-start gap-3">
              <FileVideoIcon className="mt-0.5 size-5 shrink-0 text-primary" />
              <div className="space-y-1">
                <h2 className="font-semibold">
                  {t('fiddy.admin.video.notices.create.card.title')}
                </h2>
                <p className="text-sm font-light text-muted-foreground">
                  {t('fiddy.admin.video.notices.create.card.description')}
                  <br />
                  {t('fiddy.admin.video.notices.create.card.hint')}
                </p>
              </div>
            </div>

            <Button type="button" onClick={() => setIsCreateDialogOpen(true)}>
              {t('fiddy.admin.video.notices.create.button')}
              <PlusIcon className="size-4" />
            </Button>
          </CardContent>
        </Card>

        <section className="space-y-5 pt-10">
          <h2 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">
            {t('fiddy.admin.video.notices.list.title')}
          </h2>
          <VideoNoticesTable />
        </section>
      </div>

      <VideoNoticeDialog isOpen={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} />
    </>
  );
}
